import React from 'react';

export const MemberFullContext = React.createContext({
  isAllowEdit: false,
});
